export enum Theme {
  LIGHT = "light",
  DARK = "dark",
}

export interface IBlog {
  id: number;
  title: string;
  description: string;
  date: string;
  background_image?: string;
  theme?: Theme;
}
